import { useEffect } from 'react'

const useClickOutside = (containerRef, onClickOutside, enabled = true, ignoreSelectors = []) => {
  useEffect(() => {
    if (!enabled) return undefined

    const handleMouseDown = (event) => {
      const containerRefs = Array.isArray(containerRef) ? containerRef : [containerRef]
      const containers = containerRefs.map(ref => ref.current).filter(Boolean)

      // Use the event's original path rather than `event.target`: a control inside the
      // container (e.g. a react-select chip's remove button) may be unmounted by its own
      // handler before this runs, leaving a detached target that `contains` can't find.
      const path = typeof event.composedPath === 'function' ? event.composedPath() : []
      const isInside = (container) => container.contains(event.target) || path.includes(container)

      if (containers.length > 0 && !containers.some(isInside)) {
        if (ignoreSelectors && ignoreSelectors.length > 0) {
          const shouldIgnore = ignoreSelectors.some(selector => {
            return event.target && event.target.closest && event.target.closest(selector)
          })
          if (shouldIgnore) return
        }

        onClickOutside(event)
      }
    }

    document.addEventListener('mousedown', handleMouseDown)

    return () => document.removeEventListener('mousedown', handleMouseDown)
  }, [containerRef, enabled, onClickOutside, ...(ignoreSelectors || [])])
}

export default useClickOutside
